/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewCompanyMembersFromExcelRequest } from '../../models/new-company-members-from-excel-request';

export interface NewCompanyMembersFromExcel$FormData$Params {
      body?: {
'request': NewCompanyMembersFromExcelRequest;
}
}

export function newCompanyMembersFromExcel$FormData(http: HttpClient, rootUrl: string, params?: NewCompanyMembersFromExcel$FormData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, newCompanyMembersFromExcel$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

newCompanyMembersFromExcel$FormData.PATH = '/api/company/members/from-excel';
